







































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index";
import { Bool } from "@/pbjs/external/ticket/ticket_pb";

@Component({
  name: "Completed",
})
export default class Completed extends Vue {
  @Provide() private searchForm: any = {
    ticketId: null, // ticket id
    orderId: null, // 借款ID
    completeTimeRange: [], // 完成时间
    isReloan: null,
    itemId: "",
  };
  @Provide() private labelPosition: string = "right";
  @Provide() private resultData: any = []; //table列表
  @Provide() private isSearchFormActionDone: boolean = false; //loading
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;
  @Provide() private country: any = localStorage.getItem('country');
  @Provide() private activeName: string = "first";
  @Provide() private reloanOptions: any = [
    // { name: "v0707.FirstLoan", value: Bool.BOOL_NO },
    // { name: "v0707.Reloan", value: Bool.BOOL_YES },
    { value: 100, name: "Phone Verify" },
    { value: 101, name: "Info Review" },
    // { value: 107, name: "Corporate Loan Phone Verify"},
  ];
  @Provide() private applist: any = []; 
  private created() {
    this.searchFormAction();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getAuditOrderList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getAuditOrderList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getAuditOrderList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getAuditOrderList();
  }
  // 处理工单
  handleOrder(row: any) {
    if (this.country=='mx') {
      let routeData = this.$router.resolve({
      // path: "/auditDetailMX",
      path: "/auditDetail",
      query: {
        orderid: row.ticket.orderid,
        ticketitemid: row.ticket.itemid, //工单类型
        ticketid: row.ticket.id,
        customerid: row.ticket.customerid,
        assignuid: row.ticket.assignuid,
        isAudi:"true",
        appname: row.ticket.appname
      },
    });
    window.open(routeData.href, "_blank");
    }else  {
      let routeData = this.$router.resolve({
      path: "/auditDetail",
      query: {
        orderid: row.ticket.orderid,
        ticketitemid: row.ticket.itemid, //工单类型
        ticketid: row.ticket.id,
        customerid: row.ticket.customerid,
        assignuid: row.ticket.assignuid,
        isAudi:"false",
        appname: row.ticket.appname
      },
    });
    window.open(routeData.href, "_blank");
    }
    
  }

  //  lee 搜索操作
  private searchFormAction() {
    this.pagerCount = 0;
    this.pageIndex = 1;
    this.isSearchFormActionDone = true;
    this.getAuditOrderList();
  }
  // 搜索框信息
  private searchAction(): any {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      ticketId: this.searchForm.ticketId ? Number(this.searchForm.ticketId) : null, // Ticket Id
      action: "new", //new，part，complete
      orderId: this.searchForm.orderId || null, //借款id
      isReloan: this.searchForm.isReloan ? Number(this.searchForm.isReloan) : 0, //工单类型 0：不选，1：复贷，2：首贷
      itemId: this.searchForm.itemId == "" ? [100,101,107] : [this.searchForm.itemId],
      previtemId: 0,
      appname: this.searchForm.appname?.toString()
    };
    //完成时间范围
    if (
      this.searchForm.completetimerange &&
      this.searchForm.completetimerange.length > 0
    ) {
      _arg.completetimerange =
        timeFormat(this.searchForm.completetimerange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.completetimerange[1].getTime());
    }
    return _arg;
  }
  //   获取列表
  private async getAuditOrderList() {
    let _arg: any = this.searchAction();
    const { getVerifyListReq, getVerifyListRequest }: any = await import(
      "@/request/auditOrderHandle"
    );
    let res = await getVerifyListRequest.handleHttp(getVerifyListReq(_arg), this);
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.listList == "object" ? res.listList : JSON.parse(res.listList);
        this.applist = res.applist
      if (_result) {
        this.resultData = _result.map((item: any) => {
          item.ticket.ctime = timeFormat(Number(item.ticket.ctime));
          item.ticket.assigntime = timeFormat(Number(item.ticket.assigntime));
          let previtem = "";
          switch (item.ticket.itemid) {
            case 100:
              previtem = "Phone Verify";
              break;
            case 101:
              previtem = "Info Review";
              break;
            case 107:
              previtem = "Corporate Loan Phone Verify";
              break;
          }
          let isreloanname = "";
          switch (item.ticket.isreloan) {
            case 0:
              isreloanname = this.$tc("dashbordDy.firstLoan");//"首贷";
              break;
            case 1:
              isreloanname = this.$tc("dashbordDy.CompoundLoan");//"复贷";
              break;
          }
          this.$set(item.ticket, "isreloanname", isreloanname);
          this.$set(item.ticket, "previtem", previtem);
          return item;
        });
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
      if (res.pageout.total===0) {
        this.$message.warning(this.$tc('dashbordDy.notickets'))
      }
    }
  }
}
